import RestrictedPayoutDrivers from "../../../views/RestrictedPayoutDrivers";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const RestrictedPayoutDriversRoutes = [
  {
    path: "/restricted-payout-drivers",
    component: RestrictedPayoutDrivers,
    exact: true,
    menuName: MenuNames.RESTRICTED_PAYOUT_DRIVERS,
  },
];

export default RestrictedPayoutDriversRoutes;
